import { useQuery } from 'react-query'
import ApiClient from '@quiqupltd/quiqupjs/lib/network/api-client'
import { useEnvVars } from './useEnvVars'
import { ReturnReason } from './useReturnEligibility'

type ReturnReasonsResponse = {
  reasons: ReturnReason[]
}

/**
 * Fetches return reasons from the dedicated endpoint.
 * Used as a fallback when the eligibility response doesn't include reasons
 * (e.g., cached response from before reasons were deployed).
 */
export function useReturnReasons(enabled: boolean) {
  const { env } = useEnvVars()

  return useQuery<ReturnReasonsResponse>(
    ['return-reasons'],
    () =>
      ApiClient.get({
        path: `${env.QUIQUP_PLATFORM_URL}/api/return-reasons`,
        includeAuth: false,
      }),
    { enabled, staleTime: Infinity }
  )
}
